import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumbersOnlyDirective} from './numbersOnly.directive';
import { CdkDetailRowDirective } from './cdkDetailRow.directive';

@NgModule({
   imports: [
      CommonModule
   ],
   declarations: [
      NumbersOnlyDirective,
      CdkDetailRowDirective
   ],
   exports: [
      NumbersOnlyDirective,
      CdkDetailRowDirective
   ]
})
export class DirectiveModule { }
